import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useEquipmentPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "equipment:read"),
    canWrite: roleHasPermission(role, "equipment:write"),
    canViewCosts: roleHasPermission(role, "payroll:sensitive"),
    isReadOnly:
      roleHasPermission(role, "equipment:read") && !roleHasPermission(role, "equipment:write"),
    role,
  };
}
